/*
 * Exports
 */
export { default } from './components/CancelHoldShelfPrompt.component';



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/cancel-hold-shelf-prompt/index.js